<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>Thêm mới black IP</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0"></vs-divider>
            <div class="p-6">
                <!-- IP -->
                <vs-input
                    class="w-full mt-4"
                    label="IP"
                    v-model="ip"
                    v-validate="'required|ip'"
                    name="ip"
                />
                <span class="text-danger text-sm" v-show="errors.has('ip')">{{ errors.first("ip") }}</span>

                <!-- Note -->
                <vs-textarea
                    class="w-full mt-4"
                    label="Note"
                    v-model="note"
                    v-validate="'required'"
                    name="note"
                />
                <span class="text-danger text-sm" v-show="errors.has('note')">{{ errors.first("note") }}</span>
            </div>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="save_changes" :disabled="!validateForm">Submit</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select';
import Swal from 'sweetalert2';
import { AclRule } from 'vue-acl';

export default {
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            ip: "",
            note: ""
        };
    },
    components: {
        vSelect
    },
    computed: {
        validateForm () {
            return !this.errors.any();
        },
        isSidebarActiveLocal: {
            get () {
                return this.isSidebarActive;
            },
            set (val) {
                if (!val) {
                    this.reset_data();
                    this.$emit('closeSidebar', false);
                    // this.$validator.reset()
                    // this.initValues()
                }
            }
        },
        isFormValid () {
            return !this.errors.any();
        },
        createBlackIpPermission(){
            return new AclRule('create_black_ip').or('child_create_black_ip').generate();
        }
    },
    methods: {
        save_changes () {
            if(this.$acl.not.check('createBlackIpPermission')) return;

            let vm = this;
            if (!vm.validateForm) return;

            let payload = {
                "ip": vm.ip,
                "note": vm.note
            };

            vm.$http.post("black_ip", payload)
                        .then(res => {
                            if(res.data.code == 0){
                                Swal.fire("", "Tạo black ip thành công", 'success');
                                vm.isSidebarActiveLocal = false;
                                vm.$emit("reload-ips");
                            }else{
                                Swal.fire("", res.data.msg, 'error');
                            }
                        });
        },
        reset_data () {
            this.ip = "";
            this.note = "";
        },
    },
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
.vs-sidebar--background{
    z-index: 99998;
}
</style>
